(function (){
    'use strict';

    angular
        .module('services')
        .service('PayeesService', PayeesService);

    PayeesService.$inject = ['Payee', '$http', 'API_BASE'];

    /* @ngInject */
    function PayeesService (Payee, $http, API_BASE) {
        var service = this;

        /* Payee repository methods */
        service.createPayee = createPayee;
        service.updatePayee = updatePayee;
        service.listPayees = listPayees;
        service.deletePayee = deletePayee;


        /* New functions by Marcus */
        service.getByFilter = getByFilter;

        // Payees Pagination
        service.payees = [];
        service.totalItems = 0;
        service.to = 0;
        service.itemsPerPage = 0;
        
        function createPayee(data) {
            return new Payee(prepareData(data)).save();
        }

        function updatePayee(data) {
            return new Payee({id: data.id}).update(prepareData(data));
        }
        
        function listPayees(query) {
            return Payee.where(query)
                .then(res => {
                    service.payees = res.data.data;
                    service.totalItems = res.data.total;
                    service.to = res.data.to;
                    service.itemsPerPage = res.data.per_page;
                    service.currentPage = res.data.current_page;

                    return service;
                });
        } 

        function deletePayee(id) {
            return Payee.destroy(id);
        }
        
        function prepareData(data) {
            return {
                name: data.name
            };
        }

        function getByFilter (query) {
            return $http.get(API_BASE + '/payees',{params:query});
        }
    }
})();